import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {ClientContactsPage} from "./-page/client-contacts.page";
import {ClientContactsPending} from "./-page/client-contacts.pending";
import {clientContactsSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/clients/$clientId/contacts/")({
  component: RouteComponent,
  pendingComponent: ClientContactsPending,
  staticData: {meta: {labelDescriptor: routeMessages.contacts}},
  validateSearch: (search) => clientContactsSearchSchema.parse(search),
});

function RouteComponent() {
  const {clientId} = useParams({strict: false}) as {clientId: string};
  const {includeDeleted} = Route.useSearch();

  return <ClientContactsPage clientId={clientId} includeDeleted={includeDeleted} />;
}
